import { createSelector } from "reselect";

const actionAuthorizationReducer = state =>
  state.get("actionAuthorizationReducer");
export const selectValidLink = createSelector(
  [actionAuthorizationReducer],
  actionReducer => {
    return actionReducer.get("validLink").toJS();
  }
);
export const selectValidPassCodeLink = createSelector(
  [actionAuthorizationReducer],
  actionReducer => {
    return actionReducer.get("validPassCode").toJS();
  }
);

export const selectPaansCheck = createSelector(
  [actionAuthorizationReducer],
  actionReducer => {
    return actionReducer.get("paansStatus").toJS();
  }
);

export const sendPassCodeRes = createSelector(
  [actionAuthorizationReducer],
  actionReducer => {
    return actionReducer.get("sendPassCodeRes").toJS();
  }
);
export const selectMagicLink = createSelector(
  [actionAuthorizationReducer],
  actionReducer => {
    return actionReducer.get("magicLink").toJS();
  }
);
export const selectActionData = createSelector(
  [actionAuthorizationReducer],
  actionReducer => {
    return actionReducer.get("actionData").toJS();
  }
);
export const selectActionDetail = createSelector(
  [actionAuthorizationReducer],
  actionReducer => {
    return actionReducer.get("actionDetail").toJS();
  }
);

export const selectActionTypes = createSelector(
  [actionAuthorizationReducer],
  actionReducer => {
    return actionReducer.get("actionTypes").toArray();
  }
);
export const selectActionValidations = createSelector(
  [actionAuthorizationReducer],
  actionReducer => {
    return actionReducer.get("actionValidations").toArray();
  }
);
export const selectStatus = createSelector(
  [actionAuthorizationReducer],
  actionReducer => {
    return actionReducer.get("status");
  }
);
export const selectLinkIsExpired = createSelector(
  [actionAuthorizationReducer],
  actionReducer => {
    return actionReducer.get("linkIsExpired");
  }
);

const errorAuthorizationReducer = state =>
  state.get("errorAuthorizationReducer");
export const selectErrors = createSelector(
  [errorAuthorizationReducer],
  errorReducer => {
    return errorReducer.get("errors").toJS();
  }
);
export const selectRequestActive = createSelector(
  [actionAuthorizationReducer],
  actionReducer => {
    return actionReducer.get("requestIsActive");
  }
);
export const selectConfirmationIsCompleted = createSelector(
  [actionAuthorizationReducer],
  actionReducer => {
    return actionReducer.get("confirmationIsCompleted");
  }
);

export const selectSettings = createSelector(
  [actionAuthorizationReducer],
  actionReducer => {
    return actionReducer.get("settings");
  }
);
